import React from 'react';

export default class ErrorBoundary extends React.Component
{
    state = {
        errored: false
    };

    static getDerivedStateFromError(error)
    {
        return { errored: true };
    }

    componentDidCatch(error, errorInfo)
    {
        // Here we can also log the error to an error reporting service
        console.error(error, errorInfo);
    }

    render()
    {
        if (this.state.errored) {
            return <p>Something went wrong.</p>;
        }

        return this.props.children;
    }
}